/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from "react"
import { sendSms, sendEmailCode } from "service/sign"
import { OK } from "utils/constant"
import { handleCaptchaCode } from "utils/verify"
import { filter } from "utils/filter"
import { checkCaptcha, getCaptcha } from "utils/utils"

export function useSendMessage(startTime: any, setStartTime: (arg0: boolean) => void, canSend: any, setCanSend: (arg0: boolean) => void, area: any, value: any, setHint: (arg0: string) => void, action = 'login', type = 'phone', token = undefined, resetComponent = (falg?) => { }) {
  return useCallback(async () => {
    if (startTime) return
    if (!canSend) return
    const text = type === 'phone' ? '手机' : '邮箱'
    if (!value) {
      setHint('请输入' + text)
      return
    }
    setCanSend(false)
    try {
      let data
      if (type === 'phone') {
        //yunpian验证方式
        if (window['captcha_type'] !== 'aliyun-nvc') {
          if (checkCaptcha()) {
            setHint('请先通过人机验证')
            resetComponent()
            setCanSend(true)
            return
          } else {
            data = await sendSms({
              captcha: getCaptcha(),
              action: action,
              cc: area.calling_code,
              phone: value
            }, token)
            resetComponent()
          }
        } else {
          data = await sendSms({
            test: getCaptcha(),
            action: action,
            cc: area.calling_code,
            phone: value
          }, token)
        }

      } else {
        if (window['captcha_type'] !== 'aliyun-nvc') {
          if (checkCaptcha()) {
            setHint('请先通过人机验证')
            resetComponent()
            setCanSend(true)
            return
          } else {
            //获取邮件验证码
            data = await sendEmailCode({
              action,
              email: value
            })
          }
        } else {
          //获取邮件验证码
          data = await sendEmailCode({
            test: getCaptcha(),
            action,
            email: value
          })
        }
      }
      if (data.status === OK) {
        setStartTime(true)
        window['nvcReset']()
        resetComponent()
      } else {
        resetComponent(true)
        // window['getNC']()
        const code = data.captcha_code
        if (data.code === 20011) {
          setHint('请先通过人机验证')
          handleCaptchaCode(code)
          if (code === "800" || code === "900") {
            setHint('人机验证不通过')
          }
        } else if (typeof (data.error) == 'string') {
          window['nvcReset']()
          setHint(data.error)
        } else {
          window['nvcReset']()
          setHint(filter(data.code, data.error))
        }
      }
      window['nvcReset']()
      // resetComponent()
    } catch (error) {
      resetComponent()
      console.log(error)
      window['nvcReset']()
      setHint('网络错误')
    }
    setCanSend(true)
  }, [startTime, setStartTime, canSend, setCanSend, area, value, setHint, action, type, token, resetComponent])
}
